module.exports = __webpack_public_path__ + "ce16273fcba3746ac1010508b93946b8.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Lato-Light.woff2
// module id = 691
// module chunks = 0